export class ConversionDeduper {
  private readonly sentKeys = new Set<string>();

  has(key: string): boolean {
    return this.sentKeys.has(key);
  }

  add(key: string): void {
    this.sentKeys.add(key);
  }

  clear(): void {
    this.sentKeys.clear();
  }

  getKeys(): readonly string[] {
    return Array.from(this.sentKeys);
  }

  get size(): number {
    return this.sentKeys.size;
  }
}
